import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { tempFinanceBook } from 'api/administrador/finance';

const BOOK_PATH = { caja_menor: '/plataforma/administrador/finanzas/flujo-caja', bancos: '/plataforma/administrador/finanzas/bancos' };

/**
 * Acceso temporal a una vista de Finanzas (api/administrador/finance.js › TEMP_FINANCE_ACCESS): en las
 * demás páginas de Finanzas lleva al usuario a su vista. `book` = la vista de esta página, si tiene.
 */
export default function TempAccessRedirect({ book, children }) {
  const { user } = useAuth();
  const tempBook = tempFinanceBook(user);
  if (tempBook && tempBook !== book) return <Navigate to={BOOK_PATH[tempBook]} replace />;
  return children;
}
